import SelectInput from 'components/atoms/form/SelectInput/SelectInput'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import moment from 'moment'
import React, { Component } from 'react'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import HotelCloseoutService from 'services/HotelCloseoutService'
import {getCurrentDate, getDateStringFromDate, isArrayNotEmpty, isCompletedHotelInfoHistory, isReadOnly} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './InventoryAlerts.scss'

class InventoryAlerts extends Component {

    currentYear = getCurrentDate().getFullYear()
    nextYear = this.currentYear + 1

    constructor(props) {
        super(props)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleDayClick = this.handleDayClick.bind(this)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)

        if (!hotelCode) {
            // Go home
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }
        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    handleDayClick = (day, { selected }, closeoutDays, selectedYear) => {
        let closeoutDaysForSelectedYear = closeoutDays[selectedYear]

        if (selected) {
            const selectedIndex = closeoutDaysForSelectedYear.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            );
            const deleted = closeoutDaysForSelectedYear.splice(selectedIndex, 1);
        } else {
            closeoutDaysForSelectedYear.push(day);
        }

        this.setState({
            closeoutDays: {
                closeoutDays,
                [selectedYear]: [...closeoutDaysForSelectedYear]
            }
        })
    }

    validationSchema = Yup.object().shape({
    })

    initialValues = {
        consolidatedCloseouts: [], selectedYear: this.currentYear
    }

    async componentDidMount() {

        let consolidatedCloseouts = {
            [this.currentYear]: [],
            [this.nextYear]: []
        }

        if(isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory))
        {
            let closeoutsInResponse = this.state.hotelInfoCompletedHistory.newEntity.hotelCloseouts.closeouts
            let individualCloseoutDaysInResponse = []
            if (isArrayNotEmpty(closeoutsInResponse)) {
                closeoutsInResponse.forEach(closeoutInResponse => {
                    individualCloseoutDaysInResponse.push(...this.enumerateDaysBetweenDates(closeoutInResponse.startDate, closeoutInResponse.endDate))
                })
            }
            individualCloseoutDaysInResponse.sort()
            individualCloseoutDaysInResponse.forEach(date => {
                const year = moment(date).year()
                if (consolidatedCloseouts[year]) {
                    consolidatedCloseouts[year].push(date)
                } else {
                    consolidatedCloseouts[year] = []
                    consolidatedCloseouts[year].push(date)
                }
            })

            this.setState({
                rateplans: closeoutsInResponse && closeoutsInResponse.length > 0 ? closeoutsInResponse.map(closeouts => closeouts.ratePlanCode) : [],
                initialValues: {
                    ...this.state.initialValues,
                    consolidatedCloseouts: consolidatedCloseouts
                },
                isLoading: false
            })

        }       


       else { await HotelCloseoutService.getHotelCloseouts({ hotelCode: this.state.hotelCode })
            .then(response => {

                let closeoutsInResponse = response.closeouts
                let individualCloseoutDaysInResponse = []
                if (isArrayNotEmpty(closeoutsInResponse)) {
                    closeoutsInResponse.forEach(closeoutInResponse => {
                        individualCloseoutDaysInResponse.push(...this.enumerateDaysBetweenDates(closeoutInResponse.startDate, closeoutInResponse.endDate))
                    })
                }
                individualCloseoutDaysInResponse.sort()
                individualCloseoutDaysInResponse.forEach(date => {
                    const year = moment(date).year()
                    if (consolidatedCloseouts[year]) {
                        consolidatedCloseouts[year].push(date)
                    } else {
                        consolidatedCloseouts[year] = []
                        consolidatedCloseouts[year].push(date)
                    }
                })

                this.setState({
                    rateplans: response.closeouts && response.closeouts.length > 0 ? response.closeouts.map(closeouts => closeouts.ratePlanCode) : [],
                    initialValues: {
                        ...this.state.initialValues,
                        consolidatedCloseouts: consolidatedCloseouts
                    },
                    isLoading: false
                })

            }).catch(error => {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: 'There was an error while reading Inventory Closeouts data'
                })
            })
        }
    }

    handleSubmit = (data) => {
        let closeouts = data.consolidatedCloseouts

        let putCloseouts = []
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        for (const year in closeouts) {
            if (Object.hasOwnProperty.call(closeouts, year)) {
                const closeoutsForYear = closeouts[year];
                closeoutsForYear.forEach(date => {
                        if (date >= today)
                            putCloseouts.push(getDateStringFromDate(date)) 
                    }
                )
            }
        }

        putCloseouts.sort()
        const contiguousDates = this.getRelativeDates(putCloseouts)
        const dateRanges = contiguousDates.map(contiguousDatesEntry => {
            return {
                startDate: contiguousDatesEntry[0],
                endDate: contiguousDatesEntry[contiguousDatesEntry.length - 1]
            }
        })
        this.props.onPut({ hotelCode: this.state.hotelCode, closeouts: dateRanges })
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    getRelativeDates = (dates) => {
        var format = 'YYYY-MM-DD';
        var newDate = [];
        dates.forEach(function (date) {
            var lastArr, lastDate;
            if (newDate.length) {
                lastArr = newDate[newDate.length - 1];
                if (!lastArr.length)
                    lastArr.push(date);
                else {
                    var lastDate = lastArr[lastArr.length - 1];
                    if (moment(lastDate, format).add(1, 'd').format(format) == date)
                        lastArr.push(date);
                    else
                        newDate.push([date]);
                }
            }
            else
                newDate.push([date]);
        });
        return newDate;
    }

    enumerateDaysBetweenDates = (startDate, endDate) => {
        var dates = [];

        var currDate = moment(startDate).startOf('day');
        var lastDate = moment(endDate).startOf('day');

        while (currDate.diff(lastDate) <= 0) {
            dates.push(currDate.clone().toDate());
            currDate.add(1, 'days')
        }
        return dates;
    };

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    errorMessage: this.props.errorDescription,
                    showErrorModal: true
                })
            } else {
                this.props.history.push(RouteConst.ROUTE_RACK_RATES_PAGE)
            }
        }
    }

    render() {
        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange, setFieldValue }) => (
                        <Form>
                            <div className='inventory-alerts-form'>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Inventory Closeouts</li>
                                    </ol>
                                </nav>
                                <p className='inventory-alerts-form-helper-text'>{FormConst.INVENTORY_CLOSEOUTS_HELPER_TEXT}</p>
                                <div id='inventory-alerts-form-fields' className='inventory-alerts-form-fields'>
                                    {
                                        values.consolidatedCloseouts &&

                                        <div className='select-dates-view'>

                                            <p className='select-dates-view-title'>Select Closeout dates</p>

                                            <SelectInput
                                                id='select-year'
                                                label='Year: '
                                                name='selectedYear'
                                                options={[{ label: this.currentYear.toString(), value: this.currentYear.toString() }, { label: this.nextYear.toString(), value: this.nextYear.toString() }]}
                                                overridedisabledflag='true'
                                                title='Year' />

                                            <ul className="legend">
                                                <li><span className="legend-blue"></span> Selected</li>
                                                <li><span className="legend-red"></span> Current Date</li>
                                            </ul>

                                            <DayPicker
                                                numberOfMonths={12}
                                                month={new Date(values.selectedYear, 0)}
                                                canChangeMonth={false}
                                                selectedDays={values.consolidatedCloseouts[values.selectedYear]}
                                                formatDate='YYYY-MM-DD'
                                                disabledDays={{ before: new Date() }}
                                                onDayClick={(day, { selected }) => this.handleDayClick(day, { selected }, values.consolidatedCloseouts, values.selectedYear)}
                                                className={isReadOnly() ? 'disable' : ''}
                                            />
                                        </div>
                                    }
                                </div>
                                <FormFooter
                                    form={SideNavEntryMapping.HOTEL_CLOSEOUT}
                                    isSubmit
                                    submitName={FormConst.SAVE_BUTTON_TEXT}
                                    noReset
                                    submitDisabled={isSubmitting} />
                                <FormModal
                                    id='inventory-alerts-page-loading-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='inventory-alerts-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_RESET_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.resetFormData(resetForm)
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='inventory-alerts-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </div>
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        closeoutsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_INVENTORY_CLOSEOUTS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(InventoryAlerts, SideNavEntryMapping.HOTEL_CLOSEOUT))